import customajax from '../util/ajax.js';
import AutoNumeric from 'autonumeric';

export default {
  init() {
    // JavaScript to be fired 

    // autoNumeric    
    function setPriceCurrency() {
      customajax.init('propbertySearch', 'outputPropertySearch');
      const input_price_max = document.getElementById('price_max');
      const autoNumericOptionsEuro = {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        allowDecimalPadding: false,
        currencySymbol: '\u202f€',
        currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.suffix,
        roundingMethod: AutoNumeric.options.roundingMethod.halfUpSymmetric,
      };
      new AutoNumeric(input_price_max, autoNumericOptionsEuro);
    }

    // if click a button on property search page
    $('#btn-property-init').on('click', function () {
      $('#offset').val('0');
    });

    // on load the property results 
    $(window).load(function () {
      if (document.getElementById('init-dataForm') != null) {
        var initDataForm = $('#init-dataForm').attr('data-stuff');
        var res = initDataForm.split("|");
        res.map((value) => {
          let fromValue = value.split(":");
          if (fromValue[0] == 'address') {
            $('#searchTextField').val(fromValue[1]);
          }
          else if (fromValue[0] == 'price_max') {
            let setPriceMax = fromValue[1].replace('€', '').replace(/\./g, '').replace(/\s/g, '');
            $('#' + fromValue[0]).val(setPriceMax);
          } else {
            $('#' + fromValue[0]).val(fromValue[1]);
          }
        });
      }
      setPriceCurrency();
    });

    // on sort
    $(document).on('change', '#propertySort', function () {
      let orderByValue = $(this).val()
      let res = orderByValue.split(":")

      let orderByField = res[0];
      if (res[0] == 'price') {
        if ($('#dealType').val() == 'sale') {
          orderByField = 'salePrice';
        } else {
          orderByField = 'rentGross';
        }
      }

      $('#orderByField').val(orderByField);
      $('#orderByDirection').val(res[1]);
      $('#propbertySearch').submit();
    });

    // on click on pagination to call api from offset
    $('#outputPropertySearch').on('click', '.property-page', function () {
      $('#offset').val($(this).attr('data-page'));
      $('#propbertySearch').submit();
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    // google autocomplate
    function initialize() {
      var input = document.getElementById('searchTextField');
      var autocomplete = new window.google.maps.places.Autocomplete(input);
      window.google.maps.event.addListener(autocomplete, 'place_changed', function () {
        var place = autocomplete.getPlace();
        //console.log(place);
        document.getElementById('houseNumber').value = '';
        document.getElementById('street').value = '';
        document.getElementById('addressCity').value = '';
        document.getElementById('postCode').value = '';
        for (var i = 0; i < place.address_components.length; i++) {
          for (var j = 0; j < place.address_components[i].types.length; j++) {

            if (place.address_components[i].types[j] == 'street_number') {
              document.getElementById('houseNumber').value = place.address_components[i].long_name;
            }

            if (place.address_components[i].types[j] == 'route') {
              document.getElementById('street').value = place.address_components[i].long_name;
            }

            let locality_name = place.address_components[i].types[j];
            if (locality_name == 'locality' || locality_name == 'natural_feature') {
              document.getElementById('addressCity').value = place.address_components[i].long_name;
            }

            document.getElementById('postCode').value = '';
            if (place.address_components[i].types[j] == 'postal_code') {
              document.getElementById('postCode').value = place.address_components[i].long_name;
            }
          }
        }
        document.getElementById('latitude').value = place.geometry.location.lat();
        document.getElementById('longitude').value = place.geometry.location.lng();
      });
    }
    window.google.maps.event.addDomListener(window, 'load', initialize);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templatePropertysearch.js